import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Login from './pages/Login';
import Home from './pages/Home';
import Events from './pages/EventsNew';
import PromptsGeniusLoci from './pages/PromptsGeniusLoci';
import Experiences from './pages/ExperiencesNew';
import Artworks from './pages/ArtworksNew';
import Trails from './pages/TrailsNew';
import Producers from './pages/ProducersNew';
import LocalActivities from './pages/LocalActivitiesNew';
import Souvenirs from './pages/SouvenirsNew';
import About from './pages/About';
import Landing from './pages/Landing';
import LoadingSpinner from './components/LoadingSpinner';
import Quizzes from './pages/Quizzes';

// Componente principale con autenticazione
const MainApp = () => {
  const { user, isAdmin, loading, logout } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Login />;
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="text-center max-w-md bg-white p-8 rounded-xl shadow-lg border border-border">
          <div className="w-16 h-16 bg-error/10 text-error rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-2xl">
            🔒
          </div>
          <h1 className="text-2xl font-bold text-text-primary mb-2">
            Accesso Negato
          </h1>
          <p className="text-text-secondary mb-6">
            L'account attualmente collegato (<strong className="text-text-primary">{user?.email || 'Utente non admin'}</strong>) non dispone dei permessi di amministratore per la dashboard T-Alento.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button 
              onClick={() => logout()} 
              className="btn-primary py-2 px-6"
            >
              Disconnetti e Accedi come Admin
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Sidebar 
        isCollapsed={sidebarCollapsed} 
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
      />
      <div 
        className="flex-1 flex flex-col transition-all duration-300"
        style={{ marginLeft: sidebarCollapsed ? '64px' : '256px' }}
      >
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/esperienze" element={<Experiences />} />
            <Route path="/eventi" element={<Events />} />
            <Route path="/prompt" element={<PromptsGeniusLoci />} />
            <Route path="/quiz" element={<Quizzes />} />
            <Route path="/opere" element={<Artworks />} />
            <Route path="/sentieri" element={<Trails />} />
            <Route path="/produttori" element={<Producers />} />
            <Route path="/attivita-locali" element={<LocalActivities />} />
            <Route path="/souvenir" element={<Souvenirs />} />
            <Route path="/chi-siamo" element={<About />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </div>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simula caricamento iniziale
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<MainApp />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
